export default __webpack_public_path__ + "static/media/image-cover.a36c25b5.png";